<template>
  <div class="product">
    <!-- nav -->
    <Navbar style="height: 7.3rem" id="top" />
    <!-- banner -->
    <section class="banner">
      <img src="@/assets/images/productbanner.png" alt="" />
    </section>
    <!-- product -->
    <section class="productBox">
      <ul>
        <li v-for="(item, index) in productList" :key="index">
          <div class="product_l" :id="'Position' + index">
            <div class="img">
              <img :src="item.themeUrl" alt="" />
            </div>
            <p>{{ item.tit }}</p>
            <div @click="classify(index)">查看产品分类 ></div>
          </div>
          <div class="product_r">
            <img :src="item.img_url" alt="" />
            <div class="dis_Productimg" v-if="item.non == 1">
              <ul v-loading="loading">
                <li
                  v-for="(j, index) in item.info"
                  :key="index"
                  @click="detail(j.id)"
                >
                  <img :src="j.image" alt="" />
                  <p>{{ j.name }}</p>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </section>
    <!-- foot -->
    <Foot />
  </div>
</template>

<script>
import Navbar from "@/components/nav.vue";
import Foot from "@/components/foot.vue";
import { productList } from "@/assets/js/data.js";
import { getListData } from "@/request/http";
export default {
  name: "product",
  components: {
    Navbar,
    Foot,
  },
  data() {
    return {
      loading: true,
      productList: productList,
      List: [],
    };
  },
  watch: {
    $route() {
      this.scroll();
    },
  },
  mounted() {
    this.scroll();
    this.getList();
  },
  methods: {
    getList() {
      getListData().then((res) => {
        console.log(res);
        this.List = res.data;
        this.loading = false;
      });
    },
    classify(index) {
      console.log(index);
      this.loading = true;
      if (this.productList[index].non === 1) {
        this.productList[index].non = 0;
        return;
      }
      this.productList.forEach((item) => {
        item.non = 0;
      });
      this.productList[index].non = 1;
      this.productList[index].info = this.List[index].MomodaProducts;
      this.loading = false;
    },
    detail(id) {
      this.$router.push({ name: "productDetail", query: { id: id } });
    },
    scroll() {
      if (this.$route.query.name == undefined) {
        document.getElementById("top").scrollIntoView({ behavior: "smooth" });
      }
      if (this.$route.query.name == 0) {
        document
          .getElementById("Position0")
          .scrollIntoView({ behavior: "smooth" });
      }
      if (this.$route.query.name == 1) {
        document
          .getElementById("Position1")
          .scrollIntoView({ behavior: "smooth" });
      }
      if (this.$route.query.name == 2) {
        document
          .getElementById("Position2")
          .scrollIntoView({ behavior: "smooth" });
      }
      if (this.$route.query.name == 3) {
        document
          .getElementById("Position3")
          .scrollIntoView({ behavior: "smooth" });
      }
      if (this.$route.query.name == 4) {
        document
          .getElementById("Position4")
          .scrollIntoView({ behavior: "smooth" });
      }
      if (this.$route.query.name == 5) {
        document
          .getElementById("Position5")
          .scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.none {
  display: none;
}
.product {
  .banner {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .productBox {
    width: 80%;
    margin: 0 auto;
    ul {
      margin-bottom: 6rem;
      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 1rem;
        .product_l {
          width: 30%;
          background: #f5bf4a;
          height: 24rem;
          text-align: center;
          line-height: 4;
          color: #fff;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          flex-direction: column;
          p {
            font-size: 2rem;
            height: 20%;
            line-height: 2;
          }
          > div {
            font-size: 1.5rem;
            border-top: 1px solid #fff;
            cursor: pointer;
            width: 100%;
            height: 22%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .img {
            height: 57%;
            img {
              width: 9rem;
              height: 9rem;
              margin-top: 3rem;
            }
          }
        }
        .product_r {
          width: 69%;
          position: relative;
          > img {
            width: 100%;
            height: 24rem;
          }
          .dis_Productimg {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background: #fff;
            border: 1px solid #eee;
            overflow: auto;
            ul {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              flex-wrap: wrap;
              li {
                width: 25%;
                display: flex;
                flex-direction: column;
                margin-top: 1rem;
                cursor: pointer;
                img {
                  width: 9rem;
                  height: 9rem;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
